import {createLazyResourceTableUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {IntegrationTypeModel} from '../../../models/api/integrationTypesModel';
import {AppAction} from '../../appActions';
import {LazyResourceTable, ResourceTableStatusesEnum} from '../../appTypes';
import {PushStatusActionsEnum} from '../../pushStatus/pushStatusActions';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {IntegrationTypesActionsEnum} from './integrationTypesActions';

const integrationTypesUpdatedReducer = createLazyResourceTableUpdatedReducer(
  'integrationTypes',
  (integrationType) => integrationType.id,
);

export function integrationTypesReducer(
  state: LazyResourceTable<string, IntegrationTypeModel>,
  action: AppAction,
): LazyResourceTable<string, IntegrationTypeModel> {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED:
      return integrationTypesUpdatedReducer(state, action);

    // When live updates is disconnected we should mark the store as stale so we will
    // refresh when they reconnect.
    case PushStatusActionsEnum.PUSH_DISCONNECTED:
      return {
        ...state,
        isStale: true,
      };

    case IntegrationTypesActionsEnum.FETCH_INTEGRATION_TYPES:
      return {
        ...state,
        status: ResourceTableStatusesEnum.LOADING,
        error: undefined,
      };

    case IntegrationTypesActionsEnum.FETCH_INTEGRATION_TYPES_COMPLETED:
      return {
        ...integrationTypesUpdatedReducer(state, {
          ...action,
          payload: {
            result: {
              integrationTypes: action.payload,
            },
          },
        }),
        status: ResourceTableStatusesEnum.LOADED,
        error: undefined,
        isStale: false,
      };

    case IntegrationTypesActionsEnum.FETCH_INTEGRATION_TYPES_FAILED:
      return {
        ...state,
        status: ResourceTableStatusesEnum.FAILED,
      };

    case IntegrationTypesActionsEnum.FETCH_INTEGRATION_TYPE_DESCRIPTION_COMPLETED: {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const integrationType = state.byId[action.payload.integrationId]!;
      return {
        ...state,
        byId: {
          ...state.byId,
          [integrationType.id]: {
            ...integrationType,
            longDescription: action.payload.description,
          },
        },
      };
    }

    default:
      return state;
  }
}
